import { Phone, MessageSquare, Navigation } from "lucide-react";
import { phoneHref } from "../../lib/formatters";

const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));

export const jobAddressText = (job) => {
  const parts = [job?.street, job?.city, job?.state, job?.zip_code].filter((p) => p && String(p).trim());
  return parts.length ? parts.join(", ") : (job?.address || "").trim();
};

const directionsHref = (address) => {
  const q = encodeURIComponent(address);
  return isIOS() ? `https://maps.apple.com/?daddr=${q}` : `https://www.google.com/maps/dir/?api=1&destination=${q}`;
};

const smsHref = (phone) => `sms:${(phone || "").replace(/[^\d+]/g, "")}`;

const Action = ({ href, icon: Icon, label, testId, external }) => (
  <a
    href={href}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="flex-1 min-w-[6.5rem] inline-flex items-center justify-center gap-1.5 h-11 rounded-lg border border-slate-200 bg-white text-slate-800 text-sm font-medium active:bg-slate-100 hover:bg-slate-50"
    data-testid={testId}
  >
    <Icon className="w-4 h-4" /> {label}
  </a>
);

// One-tap call / text the superintendent and directions to the site. Renders nothing if no data.
const JobQuickActions = ({ job }) => {
  if (!job || job.is_system_job) return null;
  const superPhone = job.contacts?.superintendent?.phone;
  const superName = job.contacts?.superintendent?.name;
  const address = jobAddressText(job);
  if (!superPhone && !address) return null;
  return (
    <div className="space-y-1" data-testid="job-quick-actions">
      <div className="flex flex-wrap gap-2">
        {superPhone && <Action href={phoneHref(superPhone)} icon={Phone} label="Call Super" testId="quick-call-super" />}
        {superPhone && <Action href={smsHref(superPhone)} icon={MessageSquare} label="Text Super" testId="quick-text-super" />}
        {address && <Action href={directionsHref(address)} icon={Navigation} label="Directions" testId="quick-directions" external />}
      </div>
      {superPhone && <p className="text-xs text-muted-foreground">Superintendent: {superName || superPhone}</p>}
    </div>
  );
};

export default JobQuickActions;
